import types, { TFilters } from "./types";
import { ActionType } from "typesafe-actions";
import * as actions from "./actions";

export type TAuthAction = ActionType<typeof actions>;

export interface BaseAction {
  type: string;
  payload?: any;
}

interface IFiltersModel {
  filters: TFilters;
}

export const initialState: IFiltersModel = {
  filters: {
    search: undefined,
    category: undefined,
    subcategory: undefined,
    priceRange: undefined,
    sortBy: undefined,
  },
};

const FiltersReducer = (
  state: IFiltersModel = initialState,
  action: BaseAction
): IFiltersModel => {
  switch (action.type) {
    case types.CLEAR_FILTERS:
      return {
        ...state,
        filters: {
          search: undefined,
          category: undefined,
          subcategory: undefined,
          priceRange: undefined,
          sortBy: undefined,
        },
      };
  }
  return state;
};
export default FiltersReducer;
